
<h2 mat-dialog-title>Accetta Termini e Condizioni</h2>
    <mat-dialog-content>
      <p>Per inviare la Fattura al server, devi accettare i termini del Servizio:</p>
      <button 
        *ngIf="organization_source === 'BEIZY'"
        matButton
        (click)="legalConditionsRedirect()">
        <mat-icon>link</mat-icon>
        Termini e condizioni di Beizy
      </button>
      <!-- different text for different sources -->
      <p 
        *ngIf="organization_source === 'BEIZY'"
        class="mt-3">
        Autorizzo IZY Srl al trattamento dei dati che sto per inviare. Confermo che le informazioni inserite sono veritiere e accetto i Termini e Condizioni:
      </p>
      <p 
        *ngIf="organization_source === 'CAF UIL Toscana'"
        class="mt-5">
        Autorizzo CAF UIL Toscana al trattamento dei dati che sto per inviare. Confermo che le informazioni inserite sono veritiere e accetto i Termini e Condizioni:
      </p>
      <mat-checkbox [(ngModel)]="confirmed">Confermo quanto riportato e accetto</mat-checkbox>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Indietro</button>
      <button mat-raised-button color="primary" [disabled]="!confirmed" (click)="confirm()">
        <mat-icon>check</mat-icon>
        Confermo
      </button>
    </mat-dialog-actions>